import { isPromise } from '@musinsa/packages-functional';

export const createPromiseStore = (
  key: string,
  promiseMap = new Map<string, Promise<unknown>>(),
) => {
  const batch =
    <Args extends unknown[], Return>(func: (...args: Args) => Return) =>
    (...args: Args): Return => {
      if (promiseMap.has(key)) {
        // biome-ignore lint/style/noNonNullAssertion: Safe to use non-null assertion after has() check
        return promiseMap.get(key)! as Return;
      }

      const promise = func(...args);

      if (isPromise(promise)) {
        promise.then(() => {
          promiseMap.delete(key);
        });

        promiseMap.set(key, promise as unknown as Promise<unknown>);
      }

      return promise;
    };

  return {
    batch,
  };
};
